import { useState, useEffect } from 'react';
import { useScroll } from '@one/react-utils';

export const PPP_BAR_HEIGHT = 46;

const useIsPPPBarOffFold = () => {
    const [isPPPOffFold, setIsPPPOffFold] = useState(false);
    const scrollLength = useScroll({ wait: 10 });

    useEffect(() => {
        setIsPPPOffFold(scrollLength >= PPP_BAR_HEIGHT);
    }, [scrollLength]);

    return { isPPPOffFold };
};

export default useIsPPPBarOffFold;
